import "./App.scss";

import {
  About,
  Footer,
  Header,
  Testimonial,
  Consultancy,
  Trainning,
} from "./container";
import { Navbar } from "./components";

const App = () => {
  return (
    <div className="app">
      <Navbar />
      <Header />
      <Consultancy />
      <Trainning />
      <About />
      <Testimonial />
      <Footer />
    </div>
  );
};

export default App;
